import type { SupportedLanguage } from '../../i18n/routes'

const homeMessages = {
  contactAction: {
    it: 'Raccontaci che auto cerchi',
    en: 'Tell us what car you are looking for',
  },
  contactBody: {
    it: 'Raccontaci cosa cerchi. Ti aiutiamo a capire quale veicolo e quale servizio sono adatti, senza aggiungere passaggi inutili.',
    en: 'Tell us what you need. We will help you understand which vehicle and service fit, without adding unnecessary steps.',
  },
  contactTitle: {
    it: 'Una domanda chiara merita una risposta concreta.',
    en: 'A clear question deserves a practical answer.',
  },
  heroImageAlt: {
    it: 'TS Auto, auto sportiva nera in uno showroom con dettagli rossi',
    en: 'TS Auto, black sports car in a showroom with red accents',
  },
  journeyBuyAction: { it: 'Vedi tutti i veicoli', en: 'See all vehicles' },
  journeyBuyBody: {
    it: 'Auto nuove, usate e veicoli commerciali selezionati. Parti dai dati disponibili e chiedi ciò che manca.',
    en: 'Selected new, used and commercial vehicles. Start with the available facts and ask for anything missing.',
  },
  journeyBuyTitle: { it: 'Scegliere', en: 'Choose' },
  journeyIntro: {
    it: 'Che tu stia cercando un’auto o debba vendere la tua, il percorso parte dalle informazioni utili.',
    en: 'Whether you are looking for a car or need to sell yours, the process starts with useful information.',
  },
  journeySellAction: { it: 'Valuta la tua auto', en: 'Value your car' },
  journeySellBody: {
    it: 'Permuta, intermediazione e conto vendita vengono valutati sul caso concreto, con passaggi spiegati prima di decidere.',
    en: 'Trade-in, brokerage and consignment are assessed case by case, with each step explained before you decide.',
  },
  journeySellTitle: { it: 'Vendere', en: 'Sell' },
  journeyTitle: { it: 'Due direzioni, lo stesso metodo chiaro.', en: 'Two directions, the same clear method.' },
  metadataDescription: {
    it: 'TS Auto: veicoli selezionati e informazioni da verificare prima di scegliere.',
    en: 'TS Auto: selected vehicles and facts to verify before choosing.',
  },
  metadataTitle: { it: 'TS Auto — Auto scelte con chiarezza', en: 'TS Auto — Cars selected with clarity' },
  servicesAction: { it: 'Scopri i servizi', en: 'Explore services' },
  servicesBody: {
    it: 'Le opzioni vengono approfondite in base al veicolo e alla tua situazione, senza pacchetti indistinti.',
    en: 'Options are discussed according to the vehicle and your situation, without one-size-fits-all packages.',
  },
  servicesFinanceBody: {
    it: 'Finanziamenti personalizzati e pagamenti dilazionati tramite partner del settore.',
    en: 'Tailored finance and instalment payments through sector partners.',
  },
  servicesFinanceTitle: { it: 'Finanziamento', en: 'Finance' },
  servicesRentalBody: {
    it: 'Noleggio auto a breve termine per esigenze definite nel tempo.',
    en: 'Short-term car rental for needs with a defined time frame.',
  },
  servicesRentalTitle: { it: 'Noleggio breve', en: 'Short-term rental' },
  servicesSupportBody: {
    it: 'Pratiche automobilistiche e assistenza attraverso officine e carrozzerie di fiducia.',
    en: 'Vehicle paperwork and support through trusted workshops and body shops.',
  },
  servicesSupportTitle: { it: 'Pratiche e assistenza', en: 'Paperwork and support' },
  servicesTitle: { it: 'Il supporto continua oltre la scelta.', en: 'Support continues beyond the choice.' },
  trustBody: {
    it: 'TS Auto è un’impresa familiare di San Giorgio delle Pertiche. Le informazioni disponibili accompagnano la scelta, prima e dopo la vendita.',
    en: 'TS Auto is a family business in San Giorgio delle Pertiche. Available information supports the choice, before and after the sale.',
  },
  trustDocumentation: { it: 'Documentazione chiara', en: 'Clear documentation' },
  trustMileage: { it: 'Chilometraggio verificato', en: 'Verified mileage' },
  trustTitle: { it: 'La fiducia si costruisce con dati leggibili.', en: 'Trust is built with legible facts.' },
  trustWarranty: { it: 'Garanzia 12 mesi', en: '12-month warranty' },
  vehicleAlt: {
    it: '{{vehicle}}, vista anteriore laterale',
    en: '{{vehicle}}, front three-quarter view',
  },
  vehicleEmpty: {
    it: 'Al momento non ci sono veicoli da mostrare. Contattaci e raccontaci cosa stai cercando.',
    en: 'There are currently no vehicles to display. Contact us and tell us what you are looking for.',
  },
  vehicleError: {
    it: 'Non riusciamo a caricare i veicoli. Riprova senza perdere la pagina.',
    en: 'We cannot load the vehicles. Try again without leaving the page.',
  },
  vehicleFallback: { it: 'Immagine del veicolo non disponibile', en: 'Vehicle image unavailable' },
  vehicleLoading: { it: 'Caricamento veicoli.', en: 'Loading vehicles.' },
  vehicleRetry: { it: 'Riprova', en: 'Try again' },
  vehicleTitle: { it: 'Un’auto reale, i dati che possiamo provare.', en: 'A real car, with facts we can substantiate.' },
  vehicleView: { it: 'Apri la scheda di {{vehicle}}', en: 'Open the {{vehicle}} details' },
  vehiclesAction: { it: 'Esplora il catalogo', en: 'Explore the catalogue' },
} as const satisfies Record<string, Record<SupportedLanguage, string>>

export type HomeMessageKey = keyof typeof homeMessages

export function translateHome(
  language: SupportedLanguage,
  key: HomeMessageKey,
  values: Record<string, string | number> = {},
) {
  return Object.entries(values).reduce(
    (message, [name, value]) => message.replaceAll(`{{${name}}}`, String(value)),
    homeMessages[key][language] as string,
  )
}
